import type {
  MapPointDto,
  ColorLegendItemDto,
} from "@/api/types/dtos/analytics/AnalyticsDto";

/**
 * Filters map points by visible colors and value range.
 * When colorFilterEnabled is false (e.g. empty color legend from legacy data),
 * the color stage is skipped entirely. Uncategorized points (null/undefined/empty
 * colorValue) always render so farms without an answer are never hidden.
 */
export function filterMapPoints(
  points: MapPointDto[],
  visibleColors: Set<string>,
  valueRange: [number, number] | null,
  colorFilterEnabled: boolean
): MapPointDto[] {
  return points.filter((p) => {
    if (colorFilterEnabled && p.colorValue && !visibleColors.has(p.colorValue)) {
      return false;
    }
    if (valueRange && p.transparencyValue != null) {
      if (p.transparencyValue < valueRange[0] || p.transparencyValue > valueRange[1]) {
        return false;
      }
    }
    return true;
  });
}

/**
 * Resolves the display label for a color value using the legend.
 * The "SIN_RESPUESTA" sentinel maps to its legend label ("Sin respuesta");
 * unknown values fall back to the raw value.
 */
export function resolveColorValueLabel(
  colorValue: string,
  colorLegend: ColorLegendItemDto[] | undefined
): string {
  const entry = colorLegend?.find((item) => item.optionValue === colorValue);
  return entry?.optionLabel ?? colorValue;
}
